module.exports = __webpack_public_path__ + "assets/img/banner-clo-mob.af20fcff.webp";